import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

import {getEvaluationTranslations} from '../constants/evaluation';

export function getEvaluationTooltipLabel(evaluation: string | Nullish): string {
  return evaluation
    ? getEvaluationTranslations()[Number(evaluation)]
    : i18n.t('entity.condition.labels.statusUnknown');
}
